<div class="table-responsive" ng-if="data.orders.data.length > 0">

    <!--<small class="pull-right pr10 total-record">Total Record : {{ data.orders.total }}</small>-->
    <!--<br>-->
    <!-- <dir-pagination-controls
            boundary-links="true"
            on-page-change="getPage(newPageNumber)"
            template-url="dirPagination.tpl.html"
            class="pagination-lg pagination pull-right pr10">
        Total Record {{data.orders.total }}
    </dir-pagination-controls> -->
    <div id="scrollable-area">
    <table class="table table-hover tc-checkbox-1" fixed-table-headers="scrollable-areas">
        <thead>
        <tr class="bg-light">
            <th>
            </th>
            <th style="min-width: 150px;">
                <!--Name And Email-->
            </th>
            <th class="text-center">Phone</th>
            <th class="text-center" style="min-width: 150px;">
                Order Id
            </th>
            <!-- <th class="text-center">
                Created
                <a ng-click="sort('created_at','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                    <i class="fa fa-sort-alpha-desc"></i>
                </a>
                <a ng-click="sort('created_at','asc')" ng-if="filterData.sort == 'desc'">
                    <i class="fa fa-sort-alpha-asc"></i>
                </a>
            </th> -->
            <th class="text-center">
                Delivery
                <a ng-click="sort('scheduled_time','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                    <i class="fa fa-sort-alpha-desc"></i>
                </a>
                <a ng-click="sort('scheduled_time','asc')" ng-if="filterData.sort == 'desc'">
                    <i class="fa fa-sort-alpha-asc"></i>
                </a>
            </th>
            <th class="text-center">Piece</th>
            <th class="text-center">Weight</th>
            <th class="text-center">Details</th>
            <th class="text-center">Driver</th>
            <th class="text-center">Delivery Time</th>
            
            <th class="text-center">
                Status
                <a ng-click="sort('status','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                    <i class="fa fa-sort-alpha-desc"></i>
                </a>
                <a ng-click="sort('status','asc')" ng-if="filterData.sort == 'desc'">
                    <i class="fa fa-sort-alpha-asc"></i>
                </a>
            </th>


            <!-- <th>
                Personel
                <a ng-click="sort('worker_id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                    <i class="fa fa-sort-alpha-desc"></i>
                </a>
                <a ng-click="sort('worker_id','asc')" ng-if="filterData.sort == 'desc'">
                    <i class="fa fa-sort-alpha-asc"></i>
                </a>
            </th> -->

        </tr>
        </thead>
        <tbody>
            <tr
                dir-paginate="item in data.orders.data | itemsPerPage: filterData.paginate"
                total-items="data.orders.total"
                current-page="data.orders.current_page"
                ng-class="{'checked': selectedItems.indexOf(item.id) > -1}"
            >
            <td class="clickable-row">
                <label class="option block mn" ng-if="item.status == 0 || item.status == null">
                    <input type="checkbox" ng-click="addSelectedItem(item.id)"
                           ng-checked="selectedItems.indexOf(item.id) > -1 || master" id="checkboxDefault-{{item.id}}">
                    <span class="checkbox mn"></span>
                </label>
            </td>
            <td class="clickable-row" ng-click="getOrderDetails(item)">
                <div class="avatar-container">
                    <div class="avatar-img">
                        {{ item.location.name.split(' ')[0][0] }}{{ item.location.name.split(' ')[1][0] }}
                    </div>
                    <div class="avatar-detail">
                        <strong style="font-weight:bold">{{ item.location.name }}</strong>
                        {{ item.location.email }}
                    </div>
                </div>
            </td>
            <td class="clickable-row text-center" ng-click="getOrderDetails(item)">
                {{ item.location.phone_number | tel }}
            </td>

            <td class="clickable-row text-center" ng-click="getOrderDetails(item)">
                {{item.unique}}
            </td>

            <!-- <td class="clickable-row text-center" ng-click="getOrderDetails(item)">{{ item.created_at | amDateFormat:'MM/DD/YYYY' }} </td> -->

            <td class="clickable-row text-center" ng-click="getOrderDetails(item)">
                <span ng-if="item.scheduled_time">{{ item.scheduled_time | amDateFormat:'MM/DD/YYYY' }}</span>
                <span ng-if="!item.scheduled_time">Flexible Date</span>
            </td>
            <!--<td class="clickable-row text-center" ng-click="getOrderDetails(item)">-->
            <!--{{ item.location.address }}-->
            <!--</td>-->
            <!--<td class="clickable-row text-center" ng-click="getOrderDetails(item)">-->
            <!--{{ item.location.address_two }}-->
            <!--</td>-->
            <!--<td class="clickable-row text-center" ng-click="getOrderDetails(item)">-->
            <!--{{ item.location.city }}-->
            <!--</td>-->
            <!--<td class="clickable-row text-center" ng-click="getOrderDetails(item)">-->
            <!--{{ item.location.state }}-->
            <!--</td>-->
            <!--<td class="clickable-row text-center" ng-click="getOrderDetails(item)">-->
            <!--{{ item.location.zipcode }}-->
            <!--</td>-->

            <!--<td class="clickable-row text-center mw200" ng-click="getOrderDetails(item)">{{ item.special_value | cut:true:40:' ...' }}</td>-->
            <td class="clickable-row text-center mw100" ng-click="getOrderDetails(item)">{{ item.piece }}</td>
            <td class="clickable-row text-center mw100" ng-click="getOrderDetails(item)">{{ item.weight }}</td>

            <!-- <td class="clickable-row text-center" ng-click="getOrderDetails(item)">
                <img 
                    ng-if="item.worker"
                    ng-src="https://s3.eu-west-2.amazonaws.com/foodeliva/{{ item.worker.profile_photo }}" 
                    class="img-responsive text-center img-circle" 
                    style="width:36px;height:36px;float:left">
                <strong class="fs21 ml5" style="float: left">{{ item.worker ? item.worker.full_name : '-' }} </strong>
            </td> -->


            <!--<td class="clickable-row text-center" ng-click="getOrderDetails(item)">{{ item.rate ? item.rate : '-' }}</td>-->
            <td class="clickable-row text-center mw200" ng-click="getOrderDetails(item)">
                {{ item.name | cut:true:40:' ...' }}
                <br ng-if="item.special_value" />
                <span ng-if="item.special_value" ng-bind-html="item.special_value | trust"></span>
            </td>
            <td class="clickable-row text-center mw200" ng-click="getOrderDetails(item)">
                {{ item.worker ? item.worker.full_name : '-' }}
            </td>
            <td class="clickable-row text-center mw200" ng-click="getOrderDetails(item)">
                {{ humanizeDuration(item.total_delivery * 1000, { units: ['d', 'h'] }) }}
            </td>

            <td class="clickable-row text-center" ng-click="getOrderDetails(item)">
                <div class="avatar-container" ng-if="item.status">
                    <div class="avatar-detail">
                        <span ng-if="item.status" ng-style="{'color': item.status.color }">{{ item.status.name }}</span>
                        <span ng-if="item.status && item.status.value == 'last' && item.estimated_delivery">ETA {{ item.estimated_delivery | amDateFormat:'hh:mm A' }}</span>
                        <span ng-if="item.status && item.status.value == 'last' && !item.estimated_delivery">Calculating...</span>
                    </div>
                </div>
                <span ng-if="!item.status">Created</span>
            </td>

        </tr>
        </tbody>
    </table>
    </div>
    <div class="paginate-area">
        <div class="row">
            <div class="col-11">
                <dir-pagination-controls
                    boundary-links="true"
                    on-page-change="getPage(newPageNumber)"
                    template-url="dirPagination.tpl.html"
                    class="pagination-lg pagination pull-right pr10">
                </dir-pagination-controls>
            </div>
            <div class="col-1 pl0">
                <select class="form-control"
                    ng-model="filterData.paginate"
                    ng-change="filter()"
                    ng-options="pageSize for pageSize in pageSizes"
                    >
                </select>
            </div>
        </div>
    </div>
</div>

<div class="text-center mt50" ng-if="isEmpty">
    <div ng-if="false">
        <img src="img/empty_page_orange.svg" alt="" width="400px">
        <br>
        <h3 style="font-size: 48px;font-weight: 800;">No orders yet</h3>
    </div>
    <h3 style="font-size: 32px;font-weight: 400;">
        None of your customers or orders matched this search. <br> Please try another search ...
    </h3>
</div>
